/** @format */

import { defaultActions } from '../../core/actionsDefault';

export const paymentDispositionConstants = {
    SELECT_CHANGE: 'payment_disposition_select',
};

export class paymentDispositionActions extends defaultActions {}
